(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};
    /**
     * Keep synchronized with \Paypal::CREDIT_CARD_INFO_PAYMENT_PROCESSOR_TYPE_ID_FIELD_NAME
     * @type {string}
     */
    window.JVZoo.Checkout.PaymentProcessorTypeIdFieldName = 'cc-info-credit-card-payment-processor-type-id';
    window.JVZoo.Checkout.Messages = {
        PLEASE_WAIT_FOR_REDIRECT_MESSAGE: "Redirecting...",
        /** response_processing_outcome_message */
        RESPONSE_PROCESSING_OUTCOME_MESSAGE_NAME: "rpom",
        RESPONSE_PROCESSING_ERROR_MESSAGE_NAME: 'responseProcessingError',
        NO_RESPONSE_ERROR_MESSAGE: 'Server was unable to respond. Please try again.',
        PROCESSING_ORDER_MESSAGE: 'Please wait while we process your order...',
        PROCESSING_PRE_APPROVAL_MESSAGE: 'Please wait while we setup your subscription...',
        buildPleaseContactSupport: function (requestId) { return 'An unexpected error has occurred. Please try again or contact the support desk for assistance.'+(requestId ? ' Request Id: '+ requestId : ''); },
        ORDER_FAILED_MESSAGE: 'Your order could not be completed.'
    };

    const CONTACT_PHONE_VALIDATION_URI = '/paypal/contactPhoneNumberValidation';
    /** CONTACT_PHONE_NUMBER_FIELD must match \Paypal::CONTACT_PHONE_NUMBER_FIELD*/
    const CONTACT_PHONE_NUMBER_FIELD = 'contact_phone_number';

    /**
     * Return the intl-tel-input instance if the library is on the page;
     * otherwise return null so we can fall back to the plain value.
     */
    function getIntlTelInputInstance(el) {
        if (window.intlTelInputGlobals &&
            typeof window.intlTelInputGlobals.getInstance === 'function') {
            return window.intlTelInputGlobals.getInstance(el);
        }
        return null;
    }

    /**
     * Return an international-format number when possible;
     * otherwise return the element's current value, trimmed.
     */
    function getInternationalNumber(el) {
        var instance = getIntlTelInputInstance(el);
        return instance ? instance.getNumber() : (el.value || '').trim();
    }

    /**
     * The ISO-2 currency code for the purchase
     * @type {null}
     * @private
     */
    var _productCurrencyIso2FieldName = null;
    window.JVZoo.Checkout.GetCurrencyIso2 = function () {
        return _productCurrencyIso2FieldName;
    }
    window.JVZoo.Checkout.SetCurrencyIso2 = function (value) {
        _productCurrencyIso2FieldName = value;
    }
    /**
     * The amount that should be used when submitting 3D Secure validation for credit card. This should be the product
     * price after discounts and w/ taxes. In the case of a recurring purchase, it should be the higher of the Trial and
     * Recurring price.
     * @type {null}
     * @private
     */
    var _product3dSecurePriceFieldName = null;
    window.JVZoo.Checkout.Get3dSecurePrice = function () {
        return _product3dSecurePriceFieldName;
    }
    window.JVZoo.Checkout.Set3dSecurePrice = function (value) {
        _product3dSecurePriceFieldName = value;
    }
    /**
     * The product owner
     * @type {int|null}
     * @private
     */
    var _vendorUserIdFieldName = null;
    window.JVZoo.Checkout.GetVendorUserId = function () {
        return _vendorUserIdFieldName;
    }
    window.JVZoo.Checkout.SetVendorUserId = function (value) {
        _vendorUserIdFieldName = parseInt(value);
    }

    window.JVZoo.Checkout.setCheckoutPaymentProcessorTypeId = function (checkoutPaymentProcessorTypeId) {
        var $element = $(window.JVZoo.Checkout.JquerySelectors.orderFormPaymentProcessorTypeId);
        if ($element.length > 0) {
            $element.first().val(checkoutPaymentProcessorTypeId);
            return true;
        }
        // find the order form so the hidden field can be added
        var $orderFormElement = $(window.JVZoo.Checkout.JquerySelectors.orderFormById);
        if ($orderFormElement.length < 1) {
            console.error(
                "Failed to find the order form element with selector: ",
                window.JVZoo.Checkout.JquerySelectors.orderFormById
            );
            return false;
        }
        // create the hidden field
        var $newElement = $('<input type="hidden">')
            .attr('name', window.JVZoo.Checkout.PaymentProcessorTypeIdFieldName)
            .val(checkoutPaymentProcessorTypeId)
        ;
        // add the element to the form
        $orderFormElement.append($newElement);
        return true;
    };

    window.JVZoo.Checkout.JquerySelectors = window.JVZoo.Checkout.JquerySelectors || {
        checkoutSections: {
            /** keep in sync with Paypal::PAYCAFE_SECTION_NAME */
            paycafeById: "div#cc-info-section[name=checkoutSectionPaycafe]",
        },
        jvzOverlay: ".jvz-overlay",
        orderFormById: "#orderform",
        orderFormPaymentProcessorTypeId: "input[type='hidden'][name='"+window.JVZoo.Checkout.PaymentProcessorTypeIdFieldName+"']",
        // these values should match the constants defined in Paypal.php
        ccInfoSectionId : "#cc-info-section",
        ccInfoErrorId : "#cc-info-error",
        ccInfoCardHolderId : "#cc-info-card-holder",
        // Keep synchronized with \Paypal::CREDIT_CARD_INFO_CARD_HOLDER_FIRST_NAME_FIELD_NAME
        ccInfoCardHolderFirstNameById : "#cc-info-card-holder-first-name",
        ccInfoCardHolderFirstNameErrorById : "#cc-info-card-holder-first-name-error",
        // Keep synchronized with \Paypal::CREDIT_CARD_INFO_CARD_HOLDER_LAST_NAME_FIELD_NAME
        ccInfoCardHolderLastNameById : "#cc-info-card-holder-last-name",
        ccInfoCardHolderLastNameErrorById : "#cc-info-card-holder-last-name-error",
        ccInfoCardHolderErrorId : "#cc-info-card-holder-error",
        ccInfoCardNumberId : "#cc-info-card-number",
        ccInfoCardNumberProxyId : "#cc-info-card-number-proxy",
        ccInfoCardNumberProxyExpiresId : "#cc-info-card-number-proxy-expires",
        ccInfoCardNumberErrorId : "#cc-info-card-number-error",
        ccInfoExpirationId : "#cc-info-expiration",
        ccInfoCardCodeId : "#cc-info-card-code",
        ccInfoExpirationErrorId : "#cc-info-expiration-error",
        ccInfoCardCodeErrorId : "#cc-info-card-code-error",
        ccInfoZipId : "#cc-info-zip",
        ccInfoZipErrorId : "#cc-info-zip-error",
        googleApplePayToggledById: '#google-apple-pay-toggled',
        whopToggleById: '#whop-toggle',
        contactEmailById: "#contact-email",
        contactEmailErrorById: "#contact_email_error",
        contactPhoneById: "#contact_phone_number",
        contactPhoneErrorById: "#contact_phone_number_error",
        contactFirstNameById: "#contact_first_name",
        contactFirstNameErrorById: "#contact_first_name_error",
        contactLastNameById: "#contact_last_name",
        contactLastNameErrorById: "#contact_last_name_error",
        recurringConsentById: "#recurring_consent",
        recurringConsentErrorId: "#recurring_consent_error",
        refundPolicyById: "#refundPolicyConsent",
        refundPolicyErrorId: "#refundPolicyConsent_error",
        shippingAddressDeliveryNameById: "#shipping_delivery_name",
        shippingAddressDeliveryNameErrorById: "#shipping_delivery_name_error",
        shippingAddressLine1ById: "#shipping_address_line_1",
        shippingAddressLine1ErrorById: "#shipping_address_line_1_error",
        shippingAddressCityById: "#shipping_city",
        shippingAddressCityErrorById: "#shipping_city_error",
        shippingAddressZipById: "#shipping_postal_code",
        shippingAddressZipErrorById: "#shipping_postal_code_error",
        shippingAddressRegionNameById: "#shipping_region",
        shippingAddressRegionNameErrorById: "#shipping_region_error",
        shippingAddressCountryById: "#shipping_country_id",
        shippingAddressCountryErrorById: "#shipping_country_id_error",
        billingAddressCardOwnerById: "#cc-info-card-holder",
        billingAddressCardOwnerErrorById: "#cc-info-card-holder-error",
        billingAddressLine1ById: "#billing_address_line_1",
        billingAddressLine1ErrorById: "#billing_address_line_1_error",
        billingAddressLine2ById: "#billing_address_line_2",
        billingAddressLine2ErrorById: "#billing_address_line_2_error",
        billingAddressCityById: "#billing_address_city",
        billingAddressCityErrorById: "#billing_address_city_error",
        billingAddressCountryIso2ById: "#billing_address_country_iso2",
        billingAddressCountryIso2ErrorById: "#billing_address_country_iso2_error",
        billingAddressUsStateIso2ById: "#billing_address_us_state_iso2",
        billingAddressUsStateIso2ErrorById: "#billing_address_us_state_iso2_error",
        billingAddressCaProvinceIso2ById: "#billing_address_ca_province_iso2",
        billingAddressCaProvinceIso2ErrorById: "#billing_address_ca_province_iso2_error",
        billingAddressRegionNameById: "#billing_address_region_name",
        billingAddressRegionNameErrorById: "#billing_address_region_name_error",
        billingAddressPostalCodeById: "#cc-info-zip",
        billingAddressPostalCodeErrorById: "#cc-info-zip-error",
        billingAddressErrorById: '#billing_address_error',
        billingAddressPhoneNumberById: '#billing_address_phone_number',
        billingAddressPhoneNumberErrorById: '#billing_address_phone_number_error',
        paycafeCheckoutSectionById: 'div#payment-buttons-paycafe, div#cc-info-section[name=checkoutSectionPaycafe]',
        showPaycafeCheckoutButtonById: '#showPaycafeCheckoutBtn',
    };

    /**
    * Exposes server side values to JS for region
    * select populate based on country select
    *
    * @param shippingCountrySelector
    * @param shippingRegionSelector
    * @param shippingCanadaCountryId
    * @param shippingUsCountryId
    * @param shippingCanadaProvinces
    * @param shippingUsStates
    * @param shippingRegionPlaceholderText
    */
    var _shippingCountrySelector = null;
    var _shippingRegionSelector = null;
    var _shippingCanadaCountryId = null;
    var _shippingUsCountryId = null;
    var _shippingCanadaProvinces = null;
    var _shippingUsStates = null;
    var _shippingRegionPlaceholderText = null;

    window.JVZoo.Checkout.setConfiguration = function (
        shippingCountrySelector,
        shippingRegionSelector,
        shippingCanadaCountryId,
        shippingUsCountryId,
        shippingCanadaProvinces,
        shippingUsStates,
        shippingRegionPlaceholderText
    ) {
        _shippingCountrySelector = shippingCountrySelector;
        _shippingRegionSelector = shippingRegionSelector;
        _shippingCanadaCountryId = shippingCanadaCountryId;
        _shippingUsCountryId = shippingUsCountryId;
        _shippingCanadaProvinces = shippingCanadaProvinces;
        _shippingUsStates = shippingUsStates;
        _shippingRegionPlaceholderText = shippingRegionPlaceholderText;
    };

    var _isRecurringProduct = false;
    var _isTrialConsentRequired = false;
    var _isCustomRefundPolicy = false;

    var _googleApplePayToggled = false;
    var _whopToggle = false;
    var _usingWhop = false;

    // shortcut for local references
    var _selectors = window.JVZoo.Checkout.JquerySelectors;
    window.JVZoo.Checkout.Hide = window.JVZoo.DisplayMessages.Hide;
    window.JVZoo.Checkout.Show = window.JVZoo.DisplayMessages.Show;

    /*
     * These values need to be synchronized with the constants in paypal.php
     */
    var PAY_BY_CARD_FLAG_FIELD_ID = 'cc-info-pay-by-credit-card-flag';
    window.JVZoo.Checkout.PayByCardJquerySelector = '#'+PAY_BY_CARD_FLAG_FIELD_ID+', [name="'+PAY_BY_CARD_FLAG_FIELD_ID+'"]';
    window.JVZoo.Checkout.PayByCardButtonJquerySelector = window.JVZoo.Checkout.PayByCardJquerySelector;
    window.JVZoo.Checkout.PayByStripeButtonJquerySelector = window.JVZoo.Checkout.PayByCardButtonJquerySelector;
    window.JVZoo.Checkout.PayByStripePaymentIntentButtonJquerySelector = '#cc-stripe-payment-intent-card-button';
    window.JVZoo.Checkout.PayByStripePaymentIntentCardJquerySelector = '#cc-stripe-payment-intent-card-element';

    var hideCreditCardFormAttribute = "data-jvz-hide-cc-form";
    var hideCreditCardFormButtonSelector = "["+hideCreditCardFormAttribute+"]";

    var showCreditCardFormAttribute = "data-jvz-show-cc-form";
    var showCreditCardFormButtonSelector = "["+showCreditCardFormAttribute+"]";

    var payByCreditCardAttribute = "data-jvz-pay-by-cc";
    var payByCreditCardButtonSelector = "["+payByCreditCardAttribute+"]";

    window.JVZoo.Checkout.setIsRecurringProduct = function (isRecurring) {
        _isRecurringProduct = isRecurring;
    };

    window.JVZoo.Checkout.getIsRecurringProduct = function () {
        return _isRecurringProduct;
    };

    window.JVZoo.Checkout.getIsGoogleApplePayToggled = function () {
        return _googleApplePayToggled;
    };

    window.JVZoo.Checkout.setIsGoogleApplePayToggled = function (isGoogleApplePayToggled) {
        _googleApplePayToggled = isGoogleApplePayToggled;

        var $element = $(window.JVZoo.Checkout.JquerySelectors.googleApplePayToggledById);
        if ($element.length > 0) {
            $element.first().val(isGoogleApplePayToggled);
            return true;
        }
    };

    /*
     * Way to check if whop is enabled as payment processor
     */
    window.JVZoo.Checkout.getIsWhopToggle = function () {
        return _whopToggle; 
    };

    window.JVZoo.Checkout.setIsWhopToggle = function (isWhopToggle) {
        _whopToggle = isWhopToggle;
        var $element = $(window.JVZoo.Checkout.JquerySelectors.whopToggleById);
        if ($element.length > 0) {
            $element.first().val(isWhopToggle);
            return true;
        }
    };

    /*
     * Way to check that whop is the payment processor to be used
     */
    window.JVZoo.Checkout.getIsUsingWhop = function () {
        return _usingWhop;
    };

    window.JVZoo.Checkout.setIsUsingWhop = function (usingWhop) {
        _usingWhop = usingWhop;
    };

    window.JVZoo.Checkout.setRequireTrialConsent = function (isTrialConsentRequired) {
        _isTrialConsentRequired = isTrialConsentRequired;
    };

    window.JVZoo.Checkout.getRequireTrialConsent = function () {
        return _isTrialConsentRequired === true;
    };

    window.JVZoo.Checkout.setIsCustomRefundPolicy = function (isCustomRefundPolicy) {
        _isCustomRefundPolicy = isCustomRefundPolicy;
    };
    
    window.JVZoo.Checkout.getIsCustomRefundPolicy = function () {
        return _isCustomRefundPolicy === true;
    };
    
    window.JVZoo.Checkout.getCurrentPaymentPrice = function () {
        const el = document.querySelector('.card-footer #cc-info-payment-button-amount #current_price');
        if (!el) return 0;
        return parseFloat(el.textContent.trim().replace(/[^0-9.]/g, '')) || 0;
    };

    window.JVZoo.Checkout.GetCreditCardInfoElements = function (rootElement) {
        var $rootElement = rootElement instanceof $ ? rootElement : $(rootElement);
        if ($rootElement.length !== 1) {
            return null;
        }

        return {
            section: $rootElement.find(_selectors.ccInfoSectionId).first(),
            error: $rootElement.find(_selectors.ccInfoErrorId).first(),
            cardHolder: $rootElement.find(_selectors.ccInfoCardHolderId).first(),
            cardHolderError: $rootElement.find(_selectors.ccInfoCardHolderErrorId).first(),
            cardNumber: $rootElement.find(_selectors.ccInfoCardNumberId).first(),
            cardNumberProxy: $rootElement.find(_selectors.ccInfoCardNumberProxyId).first(),
            cardNumberProxyExpires: $rootElement.find(_selectors.ccInfoCardNumberProxyExpiresId).first(),
            cardNumberError: $rootElement.find(_selectors.ccInfoCardNumberErrorId).first(),
            expiration: $rootElement.find(_selectors.ccInfoExpirationId).first(),
            cardCode: $rootElement.find(_selectors.ccInfoCardCodeId).first(),
            expirationError: $rootElement.find(_selectors.ccInfoExpirationErrorId).first(),
            cardCodeError: $rootElement.find(_selectors.ccInfoCardCodeErrorId).first(),
            billingAddressLine1ById: $rootElement.find(_selectors.billingAddressLine1ById).first(),
            billingAddressLine1ErrorById: $rootElement.find(_selectors.billingAddressLine1ErrorById).first(),
            billingAddressCountryIso2ById: $rootElement.find(_selectors.billingAddressCountryIso2ById).first(),
            billingAddressCountryIso2ErrorById:$rootElement.find(_selectors.billingAddressCountryIso2ErrorById).first(),
            billingAddressCityById: $rootElement.find(_selectors.billingAddressCityById).first(),
            billingAddressCityErrorById: $rootElement.find(_selectors.billingAddressCityErrorById).first(),            
            billingAddressUsStateIso2ById: $rootElement.find(_selectors.billingAddressUsStateIso2ById).first(),
            billingAddressUsStateIso2ErrorById: $rootElement.find(_selectors.billingAddressUsStateIso2ErrorById).first(),
            billingAddressCaProvinceIso2ById: $rootElement.find(_selectors.billingAddressCaProvinceIso2ById).first(),
            billingAddressCaProvinceIso2ErrorById: $rootElement.find(_selectors.billingAddressCaProvinceIso2ErrorById).first(),
            billingAddressRegionNameById: $rootElement.find(_selectors.billingAddressRegionNameById).first(),
            billingAddressRegionNameErrorById: $rootElement.find(_selectors.billingAddressRegionNameErrorById).first(),
            zip: $rootElement.find(_selectors.ccInfoZipId).first(),
            zipError: $rootElement.find(_selectors.ccInfoZipErrorId).first(),
            paymentButton: $rootElement.find(window.JVZoo.Checkout.PayByCardButtonJquerySelector).first()
        };
    };

    var showErrorField = function (selector, message) {
        var $element = $(selector);
        if ($element.length < 1) {
            console.error("Unable to find element by selector \""+selector+"\"");
            return;
        }
        if (!message) {
            $element.html(null);
            window.JVZoo.Checkout.Hide($element);
            return;
        }
        $element.html(message);
        window.JVZoo.Checkout.Show($element);
    };

    window.JVZoo.Checkout.SetFieldError = showErrorField;

    window.JVZoo.Checkout.SetCreditCardNumberError = function (message) {
        showErrorField(_selectors.ccInfoCardNumberErrorId, message);
    };

    var _setCreditCardError = function (message) {
        showErrorField(_selectors.ccInfoErrorId, message);
    };
    window.JVZoo.Checkout.CreditCardError = _setCreditCardError;

    window.JVZoo.Checkout.ShowCreditCardProcessing = function () {
        window.JVZoo.Checkout.Show($("#cc-info-processing"));
    };

    window.JVZoo.Checkout.HideCreditCardProcessing = function () {
        window.JVZoo.Checkout.Hide($("#cc-info-processing"));
    };

    window.JVZoo.Checkout.SetPayByCreditCardFlag = function (enable) {
        var $flagElement = $(window.JVZoo.Checkout.PayByCardJquerySelector);
        if (enable === true) {
            $flagElement.val(1);
        } else {
            $flagElement.val(0);
        }
        // also include a hidden input or update any existing
        var $orderFormElement = $(_selectors.orderFormById);
        var $hiddenField = $orderFormElement.find('input[name="'+PAY_BY_CARD_FLAG_FIELD_ID+'"]')
        if ($hiddenField.length > 0) {
            $hiddenField.each(function() { $(this).val(enable ? 1 : 0);})
            return;
        }
        $orderFormElement.append(
            $('<input>')
                .attr('type', 'hidden')
                .attr('id', PAY_BY_CARD_FLAG_FIELD_ID)
                .attr('name', PAY_BY_CARD_FLAG_FIELD_ID)
                .val(enable ? 1 : 0)
        );
    };

    //region Field Validation Functions
    window.JVZoo.Checkout.Validators = window.JVZoo.Checkout.Validators || {};

    window.JVZoo.Checkout.Validators.doesExist = function(target) {
        var $target = target instanceof $ ? target : $(target);
        return $target.length > 0;
    };

    window.JVZoo.Checkout.Validators.isVisible = function(target) {
        var $target = target instanceof $ ? target : $(target);
        return $target.is(':visible');
    };

    window.JVZoo.Checkout.Validators.hasRequiredWhenVisibleAttribute = function(target) {
        var $target = target instanceof $ ? target : $(target);
        return $target.data('required') === 'true';
    };

    window.JVZoo.Checkout.Validators.isChecked = function (target) {
        var $target = target instanceof $ ? target : $(target);
        return $target.is(':checked');
    };

    window.JVZoo.Checkout.Validators.hasText = function (target) {
        var $target = target instanceof $ ? target : $(target);
        if ($target.length !== 1) {
            console.log("Element was not found: ", target);
            return false;
        }
        var value = $target.val();
        if (value === null || value === undefined) {
            return false;
        }
        if (typeof value === "string" && value.trim() === '') {
            return false;
        }
        return true;
    };

    window.JVZoo.Checkout.Validators.isValidEmail = function (target) {
        var $target = target instanceof $ ? target : $(target);
        if ($target.length !== 1) {
            console.log("Element was not found: ", target);
            return false;
        }
        var value = $target.val();
        if (value === null || value === undefined || value.trim() === '') {
            return false;
        }
        // Email validation regex - RFC 5322 simplified
        var emailRegex = /^([a-z0-9+_\-]+)(\.[a-z0-9+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,15}$/i;
        return emailRegex.test(value.trim());
    };

    window.JVZoo.Checkout.Validators.hasOneSelection = function (target) {
        var $target = target instanceof $ ? target : $(target);
        if ($target.length !== 1) {
            console.log("Element was not found: ", target);
            return false;
        }
        var value = $target.val();
        if (Array.isArray(value)) {
            // has more than one item selected
            return false;
        }
        if (value === null || value === undefined) {
            return false;
        }
        if (typeof value === "string") {
            return value.trim() !== ''
        }
        return true;
    };
    //region Field Validation Rules Index

    /**
     * The index of pre-defined validation rules that can be selected for execution based on the specific needs of the
     * current payment processor.
     * @type {*|{RequireBillingAddressRegionNameById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=, *)), validation: (function(*=): boolean)}, RequireBillingAddressLine1ById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireBillingAddressCountryIso2ById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireBillingAddressUsStateIso2ById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=)), validation: (function(*=): boolean)}, RequireBillingAddressCityById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireCcInfoCardHolderFirstNameById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireBillingAddressPostalCodeById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireCcInfoCardHolderLastNameById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireBillingAddressCaProvinceIso2ById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=)), validation: (function(*=): boolean)}, RequireBillingAddressPhoneNumberById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireBillingAddressCardOwnerById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}, RequireRecurringConsentById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=)), validation: (function(*=): *)}, RequireContactEmailById: {errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: (function(*=): *), validation: (function(*=): boolean)}}}
     */
    window.JVZoo.Checkout.Validators.Index = window.JVZoo.Checkout.Validators.Index || {
        RequireRecurringConsentById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.recurringConsentById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.recurringConsentErrorId,
            errorMessage: "Please confirm trail agreement.",
            preCondition: function (target) {
                return (window.JVZoo.Checkout.getRequireTrialConsent() && window.JVZoo.Checkout.Validators.isVisible(target));
            },
            validation: window.JVZoo.Checkout.Validators.isChecked
        },
        RequireContactEmailById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.contactEmailById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.contactEmailErrorById,
            errorMessage: "Please provide a valid email address.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.isValidEmail
        },
        RequireCcInfoCardHolderFirstNameById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.ccInfoCardHolderFirstNameById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.ccInfoCardHolderFirstNameErrorById,
            errorMessage: "Please provide a first name.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireCcInfoCardHolderLastNameById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.ccInfoCardHolderLastNameById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.ccInfoCardHolderLastNameErrorById,
            errorMessage: "Please provide a last name.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressCardOwnerById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCardOwnerById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCardOwnerErrorById,
            errorMessage: "Please provide the full name.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressLine1ById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressLine1ById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressLine1ErrorById,
            errorMessage: "Please provide a street address.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressCityById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCityById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCityErrorById,
            errorMessage: "Please provide a City.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressCountryIso2ById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCountryIso2ById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCountryIso2ErrorById,
            errorMessage: "Please select Country",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasOneSelection
        },
        RequireBillingAddressUsStateIso2ById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressUsStateIso2ById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressUsStateIso2ErrorById,
            errorMessage: "Please select a state.",
            preCondition: function (target) {
                return window.JVZoo.Checkout.Validators.isVisible(target) && window.JVZoo.Checkout.GetBillingAddressCountryIso2() === 'US'
            },
            validation: window.JVZoo.Checkout.Validators.hasOneSelection
        },
        RequireBillingAddressCaProvinceIso2ById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCaProvinceIso2ById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressCaProvinceIso2ErrorById,
            errorMessage: "Please select a province.",
            preCondition: function (target) {
                return window.JVZoo.Checkout.Validators.isVisible(target) && window.JVZoo.Checkout.GetBillingAddressCountryIso2() === 'CA'
            },
            validation: window.JVZoo.Checkout.Validators.hasOneSelection
        },
        RequireBillingAddressRegionNameById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressRegionNameById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressRegionNameErrorById,
            errorMessage: "Please provide a state, province or region.",
            preCondition: function(target, rootelement) {
                return window.JVZoo.Checkout.Validators.isVisible(target) && !['US', 'CA'].includes(window.JVZoo.Checkout.GetBillingAddressCountryIso2())
            },
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressPostalCodeById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressPostalCodeById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressPostalCodeErrorById,
            errorMessage: "Please provide a postal code.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            validation: window.JVZoo.Checkout.Validators.hasText
        },
        RequireBillingAddressPhoneNumberById: {
            fieldSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressPhoneNumberById,
            errorSelector: window.JVZoo.Checkout.JquerySelectors.billingAddressPhoneNumberErrorById,
            errorMessage: "Please provide a phone number.",
            preCondition: window.JVZoo.Checkout.Validators.isVisible,
            // validation: window.JVZoo.Checkout.Validators.hasText
        }
    }

    /**
     * Returns an array of validators that includes the additional items passed into the method
     * @param additionalValidators
     * @return {({errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: function(*=): *, validation: function(*=): *}|{errorSelector: string, errorMessage: string, fieldSelector: string, preCondition: function(*=): *, validation: function(*=): boolean})[]}
     * @constructor
     */
    window.JVZoo.Checkout.Validators.DefaultValidators = function(additionalValidators) {
        if (!Array.isArray(additionalValidators)) {
            additionalValidators = [];
        }
        additionalValidators.unshift(
            window.JVZoo.Checkout.Validators.Index.RequireRecurringConsentById,
            window.JVZoo.Checkout.Validators.Index.RequireContactEmailById
        );
        return additionalValidators;
    }
    //endregion Field Validation Rules Index
    //endregion Field Validation Functions

    window.JVZoo.Checkout.SubmitOrderFormAsCreditCardPayment = function () {

        // set flag indicating credit card payment
        window.JVZoo.Checkout.SetPayByCreditCardFlag(true);

        console.log("Submitting order form.");
        window.JVZoo.Checkout.ShowCreditCardProcessing();

        // Ensure the hidden phone number field is updated with the full international format
        // right before submission. This prevents issues where a 'blur' event wasn't triggered on the input field.
        var visiblePhoneInput = document.getElementById('phone');
        var hiddenPhoneInput = document.getElementById('contact_phone_number');

        // Check that the elements exist to prevent errors
        if (visiblePhoneInput && hiddenPhoneInput && visiblePhoneInput.value.trim() !== '') {
            var internationalNumber = getInternationalNumber(visiblePhoneInput);
            // Directly update the value of the hidden input that will be submitted
            hiddenPhoneInput.value = internationalNumber;
        }

        document.getElementById("orderform").submit();

        // temporarily disable fields
        var $orderform = $(_selectors.orderFormById);
        var $inputs = $orderform.find('input');
        if ($inputs.length > 0) {
            $inputs.each(function (index, element) {
                $(element).attr("disabled", "disabled");
            });
            // re-enable after .75 seconds
            setTimeout(function () {
                var $inputs2 = $orderform.find('input');
                if ($inputs2.length > 0) {
                    $inputs2.each(function (index, element) {
                        $(element).removeAttr("disabled");
                    });
                }
            }, 1500);
        }
    };

    /**
     * @param {jQuery|element} rootElement
     * @param {array|null} validationConfigurations
     * @return {boolean}
     * @function
     */
    var _validateBillingInfoSection = function (rootElement, validationConfigurations) {
        var $rootElement = rootElement instanceof $ ? rootElement : $(rootElement);
        var allFieldsAreValid = true;
        var summaryErrorMessageName = 'validateBillingAddressInfoSectionErrorMessage';
        if (window.JVZoo.DisplayMessages) {
            window.JVZoo.DisplayMessages.RemoveByName(summaryErrorMessageName);
        }

        /*
         * Evaluate rules that a are related to payment and where the field is declared as part of the form
         */
        if (!Array.isArray(validationConfigurations) || validationConfigurations.length < 1) {
            console.warn("ValidationConfigurations array is empty.");
            return false;
        }

        for (var i = 0; i < validationConfigurations.length; i++) {
            var fieldValidationConfiguration = validationConfigurations[i];
            if (!fieldValidationConfiguration.hasOwnProperty('fieldSelector') || !fieldValidationConfiguration.fieldSelector) {
                console.error("Skipping Validation! fieldSelector is not defined for: ", fieldValidationConfiguration);
                continue;
            }

            if (!fieldValidationConfiguration.hasOwnProperty('errorSelector') || !fieldValidationConfiguration.errorSelector) {
                console.error("Skipping Validation! errorSelector is not defined for: ", fieldValidationConfiguration);
                continue;
            }

            if (!fieldValidationConfiguration.hasOwnProperty('validation') || !fieldValidationConfiguration.validation) {
                console.error("Skipping Validation! validation not defined for: ", fieldValidationConfiguration);
                continue;
            }

            var $field = $rootElement.find(fieldValidationConfiguration.fieldSelector);
            if ($field.length < 1) {
                console.warn("Skipping Validation! FieldElement not found for: ", fieldValidationConfiguration);
                continue;
            }
            $field = $field.first();

            var $errorElement = $rootElement.find(fieldValidationConfiguration.errorSelector);
            if ($errorElement.length < 1) {
                console.error("Skipping Validation! ErrorElement not found for: ", fieldValidationConfiguration);
                continue;
            }
            $errorElement = $errorElement.first();
            /*
             * Ensure we hide the error if it was previously visible
             */
            window.JVZoo.Checkout.Hide($errorElement);

            /*
             * Look for a pre-condition that has to be true prior to running the validation. If found, execute it now
             * and only continue if it returns exactly true.
             */
            if (fieldValidationConfiguration.hasOwnProperty('preCondition')
                && fieldValidationConfiguration.preCondition
                && fieldValidationConfiguration.preCondition($field, $rootElement) === false
            ) {
                if (window.JVZoo.Debug) {
                    console.debug("Pre-condition indicates validation is not required for: ", fieldValidationConfiguration);
                }
                continue;
            }

            /*
             * Perform the specified validation
             */
            if (fieldValidationConfiguration.validation($field, $rootElement)) {
                if (window.JVZoo.Debug) {
                    console.debug("Field is valid: ", fieldValidationConfiguration);
                }
                continue;
            }
            if (window.JVZoo.Debug) {
                console.warn("Validation failed for: ", fieldValidationConfiguration);
            }

            /*
             * Use specified validation message, or the default message in the error element or the fallback
             */
            if (fieldValidationConfiguration.hasOwnProperty('errorMessage') && fieldValidationConfiguration.errorMessage) {
                if (window.JVZoo.Debug) {
                    console.log("Using specified error message: ", fieldValidationConfiguration.errorMessage);
                }
                $errorElement.html(fieldValidationConfiguration.errorMessage);
            } else if (!$errorElement.html()) {
                var fallBackErrorMessage = "Please specify a valid value.";
                if (window.JVZoo.Debug) {
                    console.log('Using fallback error message: ', fallBackErrorMessage);
                }
                $errorElement.html(fallBackErrorMessage)
            } else {
                if (window.JVZoo.Debug) {
                    console.log('Using default error message: ', $errorElement.html());
                }
            }

            /*
             * Now that we are confident we can display the error message to the user, we mark the validation as failed
             */
            allFieldsAreValid = false;
            window.JVZoo.Checkout.Show($errorElement);
        }

        if (!allFieldsAreValid && window.JVZoo.DisplayMessages) {
            window.JVZoo.DisplayMessages.Add(
                'error',
                'Please review the validation messages below.',
                summaryErrorMessageName
            );
        }
        return allFieldsAreValid;
    };

    window.JVZoo.Checkout.ValidateBillingInfoSection = _validateBillingInfoSection;

    /**
     * @return {boolean}
     */
    window.JVZoo.Checkout.ValidateCreditCardInfoSection = function (rootElement) {

        var $rootElement = rootElement instanceof $ ? rootElement : $(rootElement);
        var isValid = true;
        var ccElements = window.JVZoo.Checkout.GetCreditCardInfoElements($rootElement);

        /*
         * Clear the overall error message field
         */
        showErrorField(_selectors.ccInfoErrorId, null);

        /*
         * Evaluate rules that are not related to payment
         */
        const contactEmailValue = _getContactEmail();
        if (!contactEmailValue) {
            // First try to show field-specific error
            var $emailErrorElement = $(_selectors.contactEmailErrorById);
            if ($emailErrorElement.length > 0) {
                showErrorField(_selectors.contactEmailErrorById, 'Please provide a contact email.');
            } else {
                showErrorField('Please provide a contact email in the field under "Step #1 Delivery"');
            }
            isValid = false;
        } else if (!window.JVZoo.Checkout.Validators.isValidEmail($(_selectors.contactEmailById))) {
            // First try to show field-specific error
            var $emailErrorElement = $(_selectors.contactEmailErrorById);
            if ($emailErrorElement.length > 0) {
                showErrorField(_selectors.contactEmailErrorById, 'Please provide a valid email address.');
            } else {
                showErrorField('Please provide a valid email address in the field under "Step #1 Delivery"');
            }
            isValid = false;
        } else {
            // Clear error if contact email has value
            var $emailErrorElement = $(_selectors.contactEmailErrorById);
            if ($emailErrorElement.length > 0) {
                showErrorField(_selectors.contactEmailErrorById, null);
            } else {
                window.JVZoo.Checkout.HideCreditCardInfoErrorMessage();
            }
        }

        // /* 
        //  * Phone number validation - synchronous check for empty value
        //  */
        // if (window.JVZoo.Checkout.Validators.doesExist(_selectors.contactPhoneById) 
        //     && $(_selectors.contactPhoneById).data('required') === true) {
        //     const contactPhoneValue = _getContactPhone();
        //     if (!contactPhoneValue) {
        //         // First try to show field-specific error
        //         var $phoneErrorElement = $(_selectors.contactPhoneErrorById);
        //         if ($phoneErrorElement.length > 0) {
        //             showErrorField(_selectors.contactPhoneErrorById, 'Please provide a contact phone number.');
        //         } else {
        //             // Fall back to credit card error display if phone error element doesn't exist
        //             _setCreditCardError('Please provide a contact phone number in the field under "Step #1 Delivery"');
        //         }
        //         isValid = false;
        //     } else {
        //         // Clear error if phone has value
        //         var $phoneErrorElement = $(_selectors.contactPhoneErrorById);
        //         if ($phoneErrorElement.length > 0) {
        //             showErrorField(_selectors.contactPhoneErrorById, null);
        //         } else {
        //             window.JVZoo.Checkout.HideCreditCardInfoErrorMessage();
        //         }
        //     }
        // }

    if (window.JVZoo.Checkout.Validators.doesExist(_selectors.contactFirstNameById)) {
            if (!_getContactFirstName()) {
                // First try to show field-specific error
                var $firstNameErrorElement = $(_selectors.contactFirstNameErrorById);
                if ($firstNameErrorElement.length > 0) {
                    showErrorField(_selectors.contactFirstNameErrorById, 'Please enter first name.');
                } else {
                    _setCreditCardError('Please provide a contact first name in the field under "Step #1 Delivery"');
                }
                isValid = false;
            } else {
                // Clear error if first name has value
                var $firstNameErrorElement = $(_selectors.contactFirstNameErrorById);
                if ($firstNameErrorElement.length > 0) {
                    showErrorField(_selectors.contactFirstNameErrorById, null);
                } else {
                    window.JVZoo.Checkout.HideCreditCardInfoErrorMessage();
                }
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.contactLastNameById)) {
            if (!_getContactLastName()) {
                // First try to show field-specific error
                var $lastNameErrorElement = $(_selectors.contactLastNameErrorById);
                if ($lastNameErrorElement.length > 0) {
                    showErrorField(_selectors.contactLastNameErrorById, 'Please enter last name.');
                } else {
                    _setCreditCardError('Please provide a contact last name in the field under "Step #1 Delivery"');
                }
                isValid = false;
            } else {
                // Clear error if last name has value
                var $lastNameErrorElement = $(_selectors.contactLastNameErrorById);
                if ($lastNameErrorElement.length > 0) {
                    showErrorField(_selectors.contactLastNameErrorById, null);
                } else {
                    window.JVZoo.Checkout.HideCreditCardInfoErrorMessage();
                }
            }
        }

        if (_isRecurringProduct
            && _isTrialConsentRequired
            && !$(window.JVZoo.Checkout.JquerySelectors.recurringConsentById).is(':checked')
            && !window.JVZoo.Checkout.getIsUsingWhop()
        ) {
            isValid = false;
            window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.recurringConsentErrorId);
        } else {
            window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.recurringConsentErrorId);
        }

        // Check if refund policy checkbox exists on the page
        var $refundPolicyCheckbox = $(window.JVZoo.Checkout.JquerySelectors.refundPolicyById);
        if ($refundPolicyCheckbox.length > 0 && !$refundPolicyCheckbox.is(':checked') && !window.JVZoo.Checkout.getIsUsingWhop()) {
            // First try to show field-specific error
            var $refundPolicyErrorElement = $(window.JVZoo.Checkout.JquerySelectors.refundPolicyErrorId);
            if ($refundPolicyErrorElement.length > 0) {
                showErrorField(window.JVZoo.Checkout.JquerySelectors.refundPolicyErrorId, 'Please consent to the refund policy.');
            } else {
                _setCreditCardError('The Agreement to the Refund Policy is required.');
            }
            isValid = false;
        } else if ($refundPolicyCheckbox.length > 0 && !window.JVZoo.Checkout.getIsUsingWhop()) {
            // Clear error if refund policy exists and is checked
            var $refundPolicyErrorElement = $(window.JVZoo.Checkout.JquerySelectors.refundPolicyErrorId);
            if ($refundPolicyErrorElement.length > 0) {
                showErrorField(window.JVZoo.Checkout.JquerySelectors.refundPolicyErrorId, null);
            }
        }

        //Shipping address validation
        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressDeliveryNameById)) {
            if (!_getShippingAddressDeliveryName()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressDeliveryNameErrorById);
                isValid = false;
            } else {
                 window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressDeliveryNameErrorById);
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressLine1ById)) {
            if (!_getShippingAddressLine1()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressLine1ErrorById);
                isValid = false;
            } else {
                window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressLine1ErrorById);
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressCityById)) {
            if (!_getShippingAddressCity()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressCityErrorById);
                isValid = false;
            } else {
                window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressCityErrorById);
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressRegionNameById)) {
            if (!_getShippingAddressRegionName()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressRegionNameErrorById);
                isValid = false;
            } else {
                window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressRegionNameErrorById);
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressZipById)) {
            if (!_getShippingAddressZip()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressZipErrorById);
                isValid = false;
            } else {
                window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressZipErrorById);
            }
        }

        if (window.JVZoo.Checkout.Validators.doesExist(_selectors.shippingAddressCountryById)) {
            if (!_getShippingAddressCountry()) {
                window.JVZoo.Checkout.Show(window.JVZoo.Checkout.JquerySelectors.shippingAddressCountryErrorById);
                isValid = false;
            } else {
                window.JVZoo.Checkout.Hide(window.JVZoo.Checkout.JquerySelectors.shippingAddressCountryErrorById);
            }
        }

        /*
         * Evaluate rules that a are related to payment and where the field is declared as part of the form.
         * But only when Apple Pay/Google Pay and Whop are not being used
         */
        if(!window.JVZoo.Checkout.getIsGoogleApplePayToggled() && !window.JVZoo.Checkout.getIsWhopToggle()) {
            if (ccElements.cardHolder.length === 1) {
                if (!ccElements.cardHolder.val()) {
                    window.JVZoo.Checkout.Show(ccElements.cardHolderError);
                    isValid = false;
                } else {
                    window.JVZoo.Checkout.Hide(ccElements.cardHolderError);
                }
            }

            if (ccElements.cardNumber.length === 1) {
                if (!ccElements.cardNumber.val()) {
                    window.JVZoo.Checkout.Show(ccElements.cardNumberError);
                    isValid = false;
                } else {
                    window.JVZoo.Checkout.Hide(ccElements.cardNumberError);
                }
            }

            if (ccElements.expiration.length === 1) {
                if (!ccElements.expiration.val() || !ccElements.expiration.val().match(/^\d{2}\/\d{2}$/)) {
                    window.JVZoo.Checkout.Show(ccElements.expirationError);
                    isValid = false;
                } else {
                    window.JVZoo.Checkout.Hide(ccElements.expirationError);
                }
            }

            if (ccElements.cardCode.length === 1) {
                if (!ccElements.cardCode.val() || !ccElements.cardCode.val().match(/^\d+$/)) {
                    window.JVZoo.Checkout.Show(ccElements.cardCodeError);
                    isValid = false;
                } else {
                    window.JVZoo.Checkout.Hide(ccElements.cardCodeError);
                }
            }

            if (ccElements.zip.length === 1) {
                if (!ccElements.zip.val()) {
                    window.JVZoo.Checkout.Show(ccElements.zipError);
                    isValid = false;
                } else {
                    window.JVZoo.Checkout.Hide(ccElements.zipError);
                }
            }

            if (ccElements.billingAddressLine1ById.length === 1
                && window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressLine1ById)
            ) {
                if (!ccElements.billingAddressLine1ById.val()) {
                    window.JVZoo.Checkout.Show(ccElements.billingAddressLine1ErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressLine1ErrorById);
                }
            }

            if (ccElements.billingAddressCountryIso2ById.length === 1) {
                if (!ccElements.billingAddressCountryIso2ById.val()) {
                    window.JVZoo.Checkout.Show(ccElements.billingAddressCountryIso2ErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressCountryIso2ErrorById);
                }
            }

            if (ccElements.billingAddressCityById.length === 1) {
                if (!ccElements.billingAddressCityById.val()) {
                    window.JVZoo.Checkout.Show(ccElements.billingAddressCityErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressCityErrorById);
                }
            }
            
            //Clean error fields selectors before validating            
            if (!window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressUsStateIso2ById)) {
                window.JVZoo.Checkout.Hide(ccElements.billingAddressUsStateIso2ErrorById);
            }

            if (ccElements.billingAddressUsStateIso2ById.length === 1
                && window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressUsStateIso2ById) 
            ) {
                if (!ccElements.billingAddressUsStateIso2ById.val()) {
                    $(ccElements.billingAddressUsStateIso2ErrorById).text("Please provide a valid State/Province.");
                    window.JVZoo.Checkout.Show(ccElements.billingAddressUsStateIso2ErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressUsStateIso2ErrorById);
                }
            }

            if (!window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressCaProvinceIso2ById)) {
                window.JVZoo.Checkout.Hide(ccElements.billingAddressCaProvinceIso2ErrorById);
            }
            if (ccElements.billingAddressCaProvinceIso2ById.length === 1
                && window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressCaProvinceIso2ById)
            ) {
                if (!ccElements.billingAddressCaProvinceIso2ById.val() ){
                    $(ccElements.billingAddressCaProvinceIso2ErrorById).text("Please provide a valid State/Province.");
                    window.JVZoo.Checkout.Show(ccElements.billingAddressCaProvinceIso2ErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressCaProvinceIso2ErrorById);
                }
            }

            if (!window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressRegionNameById)) {
                window.JVZoo.Checkout.Hide(ccElements.billingAddressRegionNameErrorById);
            }

            if (ccElements.billingAddressRegionNameById.length === 1
                && window.JVZoo.Checkout.Validators.isVisible(ccElements.billingAddressRegionNameById)
            ) {
                if (!ccElements.billingAddressRegionNameById.val() ){
                    $(ccElements.billingAddressRegionNameErrorById).text("Please provide a valid State/Province.");                    
                    window.JVZoo.Checkout.Show(ccElements.billingAddressRegionNameErrorById);
                    isValid = false;
                }
                else {
                    window.JVZoo.Checkout.Hide(ccElements.billingAddressRegionNameErrorById);
                }
            }

        }

        window.JVZoo.DisplayMessages.RemoveByName('validateCreditCardInfoSectionErrorMessage');
        if (isValid !== true && window.JVZoo.DisplayMessages) {
            window.JVZoo.DisplayMessages.Add('error', 'Please review the errors shown below.', 'validateCreditCardInfoSectionErrorMessage');
        }

        return isValid;
    };

    window.JVZoo.Checkout.ShowCreditCardInfoErrorMessage = function ($section, $message) {
        $section = $section instanceof $ ? $section : $($section);
        var $errorMessageElement = $section.find('#cc-info-error');
        if ($errorMessageElement.length !== 1) {
            return;
        }
        $errorMessageElement = $errorMessageElement.first();
        $errorMessageElement.html($message);
        window.JVZoo.Checkout.Show($errorMessageElement);
    };

    window.JVZoo.Checkout.HideCreditCardInfoErrorMessage = function ($section) {
        $section = $section instanceof $ ? $section : $($section);
        var $errorMessageElement = $section.find('#cc-info-error');
        if ($errorMessageElement.length !== 1) {
            return;
        }
        $errorMessageElement = $errorMessageElement.first();
        window.JVZoo.Checkout.Hide($errorMessageElement);
    };

    window.JVZoo.Checkout.CleanCardNumberProxyHiddenFields = function (root) {
        var ccElements = window.JVZoo.Checkout.GetCreditCardInfoElements(root);
        ccElements.cardNumberProxy.val('');
        ccElements.cardNumberProxyExpires.val('');
    };

    window.JVZoo.Checkout.SetPaymentProcessingToken = function (token, expiresOn) {
        $(_selectors.ccInfoCardNumberProxyId).val(token);
        if (!expiresOn) {
            return;
        }
        $(_selectors.ccInfoCardNumberProxyExpiresId).val(expiresOn);
    };

    window.JVZoo.Checkout.isValidEmail = function (email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    // window.JVZoo.Checkout.validatePhoneNumber = async () => {
    //     const phoneInput = document.querySelector(`#${CONTACT_PHONE_NUMBER_FIELD}`);
    //     const phoneValue = phoneInput?.value;

    //     console.debug('Validating phone number');
    //     if (!window.JVZoo.Checkout.Validators.doesExist(_selectors.contactPhoneById)) {
    //         return true;
    //     }

    //     const formData = new FormData();
    //     formData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
    //     formData.append(CONTACT_PHONE_NUMBER_FIELD, phoneValue);
    //     /**
    //      * Skip the DTO check at Paypal::valid_contact_phone_number 
    //      * because the DTO is set after this endpoint call
    //      */
    //     formData.append('skip_dto_check', 1); 

    //     try {
    //         const response = await fetch(CONTACT_PHONE_VALIDATION_URI, {
    //             method: 'POST',
    //             headers: { 'Accept': 'application/json' },
    //             body: formData,
    //         });

    //         const data = await response.json();

    //         if (data.status === 'error') {
    //             _setCreditCardError('Please provide a valid contact phone in the field under "Step #1 Delivery"');
    //             return false;
    //         }

    //         window.JVZoo.Checkout.HideCreditCardInfoErrorMessage();
    //         return true;

    //     } catch (err) {
    //         console.error('Phone validation failed:', err);
    //         _setCreditCardError('Could not validate phone number. Please try again.');
    //         return false;
    //     }
    // };


    // window.JVZoo.Checkout.PayByCreditCard = function ($payBuyCreditCardButton, $creditCardInfoSection) {
    //
    //     var eventArgs = {
    //         button: $payBuyCreditCardButton,
    //         infoSection: $creditCardInfoSection,
    //         errorField: $creditCardInfoSection.find('#cc-info-error').first(),
    //         allowSubmit: true,
    //         errorMessage: null,
    //         abort: false
    //     };
    //
    //     eventArgs = validateCreditCardFields(eventArgs);
    //
    //     if (eventArgs.errorMessage) {
    //         window.JVZoo.Checkout.ShowCreditCardInfoErrorMessage($creditCardInfoSection, eventArgs.errorMessage);
    //     } else {
    //         window.JVZoo.Checkout.HideCreditCardInfoErrorMessage($creditCardInfoSection);
    //     }
    //
    //     if (!eventArgs.allowSubmit) {
    //         return;
    //     }
    //
    //     if (beforePayByCreditCardDelegates && beforePayByCreditCardDelegates.length > 0) {
    //         // call all delegates
    //         eventArgs = beforePayByCreditCardDelegates.reduce(function (eventArgs, delegate) {
    //             if (eventArgs.abort) {
    //                 return eventArgs;
    //             }
    //             return delegate(eventArgs)
    //         }, eventArgs);
    //
    //         console.log("eventArgs: ", eventArgs);
    //         // for (var index in beforePayByCreditCardDelegates) {
    //         //     var delegate = beforePayByCreditCardDelegates[index];
    //         //     eventArgs = delegate(eventArgs);
    //         // }
    //     }
    //
    //     var $errorMessageElement = $creditCardInfoSection.find('#cc-info-error');
    //     if ($errorMessageElement.length === 1) {
    //         $errorMessageElement = $errorMessageElement.first();
    //         if (!eventArgs.errorMessage) {
    //             window.JVZoo.Checkout.Hide($errorMessageElement);
    //         } else {
    //             window.JVZoo.Checkout.Show($errorMessageElement);
    //             $errorMessageElement.innerHTML(eventArgs.errorMessage)
    //         }
    //     }
    //
    //     if (!eventArgs.allowSubmit) {
    //         console.log("Aborting CC Submit");
    //         return;
    //     }
    //
    //     console.log("Submitting CC");
    // };

    /**
     *
     * @param selector
     * @return {boolean|string}
     * @private
     */
    var _getFieldValue = function(selector) {
        var $element = $(selector);
        if ($element.length < 1) {
            return false;
        }

        if($element.first().val() !== null) {
            return $element.first().val().trim();
        }

        return $element.first().val();
    };

    var _getCardHolderName = function () {
        return _getFieldValue(_selectors.ccInfoCardHolderId);
    };
    window.JVZoo.Checkout.GetCardHolderName = _getCardHolderName;

    var _getCardHolderFirstName = function () {
        return _getFieldValue(_selectors.ccInfoCardHolderFirstNameById);
    };
    window.JVZoo.Checkout.GetCardHolderFirstName = _getCardHolderFirstName;

    var _getCardHolderLastName = function () {
        return _getFieldValue(_selectors.ccInfoCardHolderLastNameById);
    };
    window.JVZoo.Checkout.GetCardHolderLastName = _getCardHolderLastName;

    var _getContactEmail = function () {
        return _getFieldValue(_selectors.contactEmailById)
    };
    window.JVZoo.Checkout.GetContactEmail = _getContactEmail;

    var _getContactPhone = function () {
        return _getFieldValue(_selectors.contactPhoneById)
    };
    window.JVZoo.Checkout.GetContactPhone = _getContactPhone;

    var _getContactFirstName = function () {
        return _getFieldValue(_selectors.contactFirstNameById)
    };
    window.JVZoo.Checkout.GetContactFirstName = _getContactFirstName;

    var _getContactLastName = function () {
        return _getFieldValue(_selectors.contactLastNameById)
    };
    window.JVZoo.Checkout.GetContactLastName = _getContactLastName;

    var _getRecurringConsent = function () {
        return _getFieldValue(_selectors.recurringConsentById)
    };
    window.JVZoo.Checkout.GetRecurringConsent = _getRecurringConsent;

    var _getRefundPolicy = function () {
        return _getFieldValue(_selectors.refundPolicyById);
    };

    window.JVZoo.Checkout.GetRefundPolicy = _getRefundPolicy;

    var _getShippingAddressDeliveryName = function () {
        return _getFieldValue(_selectors.shippingAddressDeliveryNameById);
    };

    window.JVZoo.Checkout.GetShippingAddressDeliveryName = _getShippingAddressDeliveryName;

    var _getShippingAddressLine1 = function () {
        return _getFieldValue(_selectors.shippingAddressLine1ById);
    };

    window.JVZoo.Checkout.GetShippingAddressLine1 = _getShippingAddressLine1;

    var _getShippingAddressCity = function () {
        return _getFieldValue(_selectors.shippingAddressCityById);
    }
    window.JVZoo.Checkout.GetShippingAddressCity = _getShippingAddressCity;

    var _getShippingAddressRegionName = function () {
        return _getFieldValue(_selectors.shippingAddressRegionNameById);
    };

    window.JVZoo.Checkout.GetShippingAddressRegionName = _getShippingAddressRegionName;

    var _getShippingAddressCountry = function () {
        return _getFieldValue(_selectors.shippingAddressCountryById);
    };

    window.JVZoo.Checkout.GetShippingAddressCountry = _getShippingAddressCountry;

    var _getShippingAddressZip = function () {
        return _getFieldValue(_selectors.shippingAddressZipById);
    };
    window.JVZoo.Checkout.GetShippingAddressZip = _getShippingAddressZip;
        
    var _getBillingAddressLine1 = function () {
        return _getFieldValue(_selectors.billingAddressLine1ById)
    };
    window.JVZoo.Checkout.GetBillingAddressLine1 = _getBillingAddressLine1;

    var _getBillingAddressLine2 = function () {
        return _getFieldValue(_selectors.billingAddressLine2ById);
    };
    window.JVZoo.Checkout.GetBillingAddressLine2 = _getBillingAddressLine2;

    var _getBillingAddressAllLines = function () {

        var addressLine1 = _getBillingAddressLine1();
        if ("string" !== typeof(addressLine1)) {
            return null;
        }

        var addressLine2 = _getBillingAddressLine2();
        if ("string" !== typeof(addressLine2)) {
            return addressLine1;
        }

        return addressLine1 + " " + addressLine2
    };
    window.JVZoo.Checkout.GetBillingAddressAllLines = _getBillingAddressAllLines;


    var _getBillingAddressCity = function () {
      return _getFieldValue(_selectors.billingAddressCityById);
    };
    window.JVZoo.Checkout.GetBillingAddressCity = _getBillingAddressCity;

    var _getBillingAddressCountryIso2 = function () {
        return _getFieldValue(_selectors.billingAddressCountryIso2ById);
    };
    window.JVZoo.Checkout.GetBillingAddressCountryIso2 = _getBillingAddressCountryIso2;

    var _getBillingAddressPostalCode = function () {
      return _getFieldValue(_selectors.billingAddressPostalCodeById);
    };
    window.JVZoo.Checkout.GetBillingAddressPostalCode = _getBillingAddressPostalCode;

    var _getBillingAddressState = function () {
        return window.JVZoo.Checkout.GetBillingAddressRegionBySelectedCountry();
    };
    window.JVZoo.Checkout.GetBillingAddressState = _getBillingAddressState;

    var _getBillingAddressPhoneCountryCode = function () {
        return _getFieldValue(_selectors.billingAddressPhoneCountryCodeById);
    };
    window.JVZoo.Checkout.GetBillingAddressPhoneCountryCode = _getBillingAddressPhoneCountryCode;

    var _getBillingAddressPhoneNumber = function () {
        return _getFieldValue(_selectors.billingAddressPhoneNumberById);
    };

    window.JVZoo.Checkout.GetBillingAddressPhoneNumber = _getBillingAddressPhoneNumber;

    /**
     * @return {false|string}
     * @function
     */
    window.JVZoo.Checkout.GetBillingAddressRegionBySelectedCountry = function() {
        if (_getBillingAddressCountryIso2() === 'US') {
            return _getFieldValue(_selectors.billingAddressUsStateIso2ById);
        }
        if (_getBillingAddressCountryIso2() === 'CA') {
            return _getFieldValue(_selectors.billingAddressCaProvinceIso2ById)
        }
        return _getFieldValue(_selectors.billingAddressRegionNameById);
    };

    var _setBillingAddressZipCode = function (zipCode) {
        var $element = $(_selectors.ccInfoZipId);
        if ($element.length < 1) {
            return false;
        }
        $element.val(zipCode);
        return true;
    };
    window.JVZoo.Checkout.SetBillingAddressZipCode = _setBillingAddressZipCode;

    var hideCreditCardInfoFields = function ($section) {
        window.JVZoo.Checkout.Hide($section);
        var ccFields = window.JVZoo.Checkout.GetCreditCardInfoElements($section);
        ccFields.cardNumber.val(null);
        ccFields.cardNumberProxy.val(null);
        ccFields.cardHolder.val(null);
        ccFields.expiration.val(null);
        ccFields.cardCode.val(null);
        ccFields.zip.val(null);
        var $found = $section.find('[data-jvz-require-when-visible]');
        if ($found.length > 0) {
            $found.each(function (index, element) {
                //$(element).removeAttr('data-required');
            });
        }
    };

    var showCreditCardInfoFields = function ($section) {
        window.JVZoo.Checkout.Show($section);
        var $found = $section.find('[data-jvz-require-when-visible]');
        if ($found.length > 0) {
            $found.each(function (index, element) {
                $(element).attr('required', 'required');
            });
        }
        // ensure we trigger the address province / state / region field filtering
        $section.find(_selectors.billingAddressCountryIso2ById).first().trigger('change');
    };

    var getElementBySelector = function ($rootElement, selector) {
        if (!selector) {
            console.error("Failed to find credit card info section selector as value of "+payByCreditCardAttribute);
            return false;
        }
        var $creditCardInfoSection = $rootElement.find(selector);
        if ($creditCardInfoSection.length !== 1) {
            console.error("Failed to find element using selector \""+selector+"\"");
            return false;
        }
        return $creditCardInfoSection;
    };

    var bindHideCreditCardFields = function ($rootElement) {
        var $button = $rootElement.find(hideCreditCardFormButtonSelector);
        if ($button.length < 1) {
            return;
        }
        $button = $button.first();
        var $creditCardInfoSection = getElementBySelector($rootElement, $button.attr(hideCreditCardFormAttribute));
        if (!$creditCardInfoSection) {
            return;
        }

        $rootElement.on('click', hideCreditCardFormButtonSelector, function () {
            hideCreditCardInfoFields($creditCardInfoSection);
        });
    };

    var isUsStateRequired = false;
    var setRequireUsState = function ($element, isRequired) {
        if (isRequired) {
            isUsStateRequired = true;
            $element.attr('data-required', true);
            window.JVZoo.Checkout.Show($element);
            return;
        }

        isUsStateRequired = false;
        $element.removeAttr('data-required');
        $element.val(undefined);
        window.JVZoo.Checkout.Hide($element, false, 0);
    };
    var isCaProvinceRequired = false;
    var setRequireCaState = function ($element, isRequired) {
        if (isRequired) {
            isCaProvinceRequired = true;
            $element.attr('data-required', true);
            window.JVZoo.Checkout.Show($element);
            return;
        }

        isCaProvinceRequired = false;
        $element.removeAttr('data-required');
        $element.val(undefined);
        window.JVZoo.Checkout.Hide($element, false, 0);
    };
    var isRegionNameRequired = false;
    var setRequireRegionName = function ($element, isRequired) {
        if (isRequired) {
            isRegionNameRequired = true;
            $element.attr('data-required', true);
            window.JVZoo.Checkout.Show($element);
            return;
        }

        isRegionNameRequired = false;
        $element.removeAttr('data-required');
        $element.val(undefined);
        window.JVZoo.Checkout.Hide($element, false, 0);
    };

    window.JVZoo.Checkout.filterBillingAddressFields = function ($rootElement) {
        $rootElement.on('change', _selectors.billingAddressCountryIso2ById, function (e) {
            var countryIso2Value = window.JVZoo.Checkout.GetBillingAddressCountryIso2();
            if (!countryIso2Value) { return;}
            setRequireUsState(
                $rootElement.find(_selectors.billingAddressUsStateIso2ById).first(),
                countryIso2Value === "US"
            );
            setRequireCaState(
                $rootElement.find(_selectors.billingAddressCaProvinceIso2ById).first(),
                countryIso2Value === "CA"
            );
            setRequireRegionName(
                $rootElement.find(_selectors.billingAddressRegionNameById).first(),
                countryIso2Value !== "US" && countryIso2Value !== "CA"
            );
        });
        $rootElement.find(_selectors.billingAddressCountryIso2ById).first().trigger('change');
    };

    var bindShowCreditCardFields = function ($rootElement) {
        var $element = $rootElement.find(showCreditCardFormButtonSelector);
        if ($element.length < 1) {
            return;
        }
        $element = $element.first();
        var $creditCardInfoSection = getElementBySelector($rootElement, $element.attr(showCreditCardFormAttribute));
        if (!$creditCardInfoSection) {
            return;
        }

        $rootElement.on('click', showCreditCardFormButtonSelector, function () {
            showCreditCardInfoFields($creditCardInfoSection);
            // Stubbed for feedback on changing button state and look after clicking
            // $element.prop('disabled', true ).addClass('disabled');
            if ($element.is('button')) {
                // do not disable radio buttons from clean & simple form
                $element.prop('disabled', true).css({'opacity': '0.35', 'cursor': 'not-allowed'});
            }
            window.scrollBy({
                top: 400,
                left: 0,
                behavior: "smooth",
            });
        });
    };

    var _getMessageDisplayDelegate = function() {
        if (window.JVZoo.DisplayMessages.Add) {
            return window.JVZoo.DisplayMessages.Add;
        }
        console.error("window.JVZoo.DisplayMessages is not defined so messages cannot be displayed normally. Falling back to alert messages.");
        /** define a "fallback" message display delegate that just shows an alert message */
        return function (level, msg) {
            level = level || 'error';
            if (!msg) {
                return false;
            }
            alert(level + ': ' + msg);
            return true;
        };
    } ;

    window.JVZoo.Checkout.applyBindings = function (root) {

        _userMessageDisplayDelegate = _getMessageDisplayDelegate();

        var $rootElement = root instanceof $ ? root : $(root);

        window.JVZoo.Checkout.filterBillingAddressFields($rootElement);
        bindShowCreditCardFields($rootElement);
        bindHideCreditCardFields($rootElement);

        var ccElements = window.JVZoo.Checkout.GetCreditCardInfoElements(root);
        // if they modify the card number, ensure we've cleared the hidden fields
        ccElements.cardNumber.on('change', function (event) {
            window.JVZoo.Checkout.CleanCardNumberProxyHiddenFields($rootElement);
        });
        ccElements.cardNumber.keypress(function (event) {
            window.JVZoo.Checkout.CleanCardNumberProxyHiddenFields($rootElement);
        });

        var ccInfoHasFocus = function () {
            return $rootElement.find('#cc-info-section').has(':focus').length > 0
        };

        /**
         * True when any editable input has focus (ignores submit button)
         * @return {boolean}
         */
        var ccInfoEditableFieldHasFocus = function () {
            var $elements = $rootElement
                .find('#cc-info-section input[type!=submit], #cc-info-section select, #cc-info-section option')
                .has(':focus')
            ;
            if ($elements.length > 0) {
                return true;
            }
            return false;
        };

        /*
         This takes care of changing the region input to selects on the fly so we don't have to post back
         for them and deal with the expired token issue - Kevin 4/23/20
         */
        $('#'+_shippingCountrySelector).change(function() {
            var $shippingRegion = $('#' + _shippingRegionSelector);
            var shippingRegionInitialVal = $shippingRegion.val().trim();
            var $shippingCountrySelect = $(this);
            var selectedCountryId = Number($shippingCountrySelect.val());

            if ([_shippingCanadaCountryId, _shippingUsCountryId].includes(selectedCountryId)) {
                var regionList = (selectedCountryId === _shippingCanadaCountryId) ? _shippingCanadaProvinces : _shippingUsStates;
                var $regionSelect = $('<select class="form-control" id="'+_shippingRegionSelector+'" name="'+_shippingRegionSelector+'">');

                $.each(regionList, function(cd, name) {
                    $regionSelect.append($('<option>', {value:cd}).text(name));
                });

                // Check to see if the value that was in the element being replaced is selectable in our list via value or text
                if (regionList.hasOwnProperty(shippingRegionInitialVal.toUpperCase())) {
                    $regionSelect.val(shippingRegionInitialVal.toUpperCase());
                } else {
                    $regionSelect.find('option').filter(function() {
                        return this.text.toLowerCase() === shippingRegionInitialVal.toLowerCase();
                    }).attr('selected', true);
                }

                $shippingRegion.replaceWith($regionSelect);

            } else if ($shippingRegion.is('select')) {
                $shippingRegion.replaceWith($('<input type="text" class="form-control" id="'+_shippingRegionSelector+'" name="'+_shippingRegionSelector+'" placeholder="' + _shippingRegionPlaceholderText + '">'));
            }
        });

        /*
        TODO: REFACTOR THE FOLLOWING ACCORDING TO KEVIN'S CSS ARCHITECTURE
        */
        var overlayCss = "position: fixed; /* Sit on top of the page content */\n" +
            "  display: none; /* Hidden by default */\n" +
            "  width: 100%; /* Full width (cover the whole page) */\n" +
            "  height: 100%; /* Full height (cover the whole page) */\n" +
            "  top: 0;\n" +
            "  left: 0;\n" +
            "  right: 0;\n" +
            "  bottom: 0;\n" +
            "  background-color: rgba(0,0,0,0.5); /* Black background with opacity */\n" +
            "  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */\n" +
            "  cursor: pointer; /* Add a pointer on hover */";
        $('body').append(
            $('<div id="ajax_loader" style="'+overlayCss+'"><div style="position: fixed; left: 50%; top: 50%;"><img src="/images/animated/spinner.gif"></img></div></div>')
        );
        $(document).ajaxStop(function(){
            $("#ajax_loader").hide();
        });
        $(document).ajaxStart(function(){
            $("#ajax_loader").show();
        });

        // Add async phone validation on blur
        // var $phoneInput = $('#phone'); // The visible phone input field
        // var $hiddenPhoneInput = $(_selectors.contactPhoneById); // The hidden field that stores the full international number
        // if ($phoneInput.length > 0 && $hiddenPhoneInput.length > 0 && $hiddenPhoneInput.data('required') === true) {
        //     $phoneInput.on('blur', function() {
        //         var phoneValue = $(this).val().trim();
                
        //         // Clear error if empty (empty check is done during form submit)
        //         if (!phoneValue) {
        //             showErrorField(_selectors.contactPhoneErrorById, null);
        //             return;
        //         }
                
        //         // Get the full international number from intlTelInput
        //         var fullPhoneNumber = getInternationalNumber(this);
        //         $hiddenPhoneInput.val(fullPhoneNumber);
                
        //         // Validate phone number via API
        //         var postData = new FormData();
        //         postData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        //         postData.append(CONTACT_PHONE_NUMBER_FIELD, fullPhoneNumber);
                
        //         fetch(CONTACT_PHONE_VALIDATION_URI, {
        //             method: 'POST',
        //             headers: {'Accept': 'application/json'},
        //             mode: 'same-origin',
        //             cache: 'no-cache',
        //             credentials: 'same-origin',
        //             redirect: 'error',
        //             referrerPolicy: "same-origin",
        //             body: postData,
        //         })
        //         .then(function(response) {
        //             if (!response.ok) {
        //                 throw new Error('Network response was not ok');
        //             }
        //             return response.json();
        //         })
        //         .then(function(data) {
        //             if (data.isValid === false) {
        //                 showErrorField(_selectors.contactPhoneErrorById, data.message || 'Please provide a valid phone number.');
        //             } else {
        //                 showErrorField(_selectors.contactPhoneErrorById, null);
        //             }
        //         })
        //         .catch(function(error) {
        //             console.error('Phone validation error:', error);
        //             // Don't show error on network failure, let form submission handle it
        //         });
        //     });
        // }
    };

    /**
     * This method ensures that we can display User Messages one way or another, even if that means falling back to
     * using a standard Alert message.
     * @return {function(level, message, name)}
     */
    var _userMessageDisplayDelegate = function (level, message, name) {
        //no op
    };

    window.JVZoo.Checkout.OrderFormResponseOutcome = {
        REDIRECT: 'REDIRECT',
        INCOMPLETE_RESPONSE_DATA: 'INCOMPLETE_RESPONSE_DATA'
    };

    // window.JVZoo.Checkout.FetchValidatedPhoneNumberData = function (phoneNumber) {
    //     if (window.JVZoo.Debug) {
    //         console.log('Validating Phone Number: ', phoneNumber);
    //     }
    //     var postData = new FormData();
    //     postData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
    //     postData.append('phoneNumber', phoneNumber);
    //     return fetch(
    //         '/paypal/getValidatedPhoneNumberData',
    //         {
    //             method: 'POST',
    //             headers: {'Accept': 'application/json'},
    //             mode: 'same-origin',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             redirect: 'error',
    //             referrerPolicy: "same-origin",
    //             body: postData,
    //         }
    //     )
    //     .then(function (response) {
    //         if (window.JVZoo.Debug) {
    //             console.debug(response);
    //         }
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok: ' + response.statusText);
    //         }
    //         return response.json();
    //     });
        // .then(function (responseData) {
        //     if (window.JVZoo.Debug) {
        //         console.debug("ValidateAndFormatPhoneNumber Response responseData:", responseData);
        //     }
        //     if (!responseData) {
        //         throw Error('EmptyResponseError');
        //     }
        //     if (!responseData.hasOwnProperty('ValidationResponseCode')) {
        //         throw Error('ValidationResponseCodeMissing')
        //     }
        //     if (onResponse) {
        //         return onResponse(responseData)
        //     }
        //     throw Error('MissingResponseHandler');
        // })
        // .catch(function (error) {
        //     console.error("ValidateAndFormatPhoneNumber Error:", error);
        //     if (onError) {
        //         return onError(error);
        //     }
        //     throw error
        // });
    // };

    /**
     * this objects properties should match \JVZoo\Constant\Checkout\OrderFormExitCodes constants
     */
    window.JVZoo.Checkout.OrderFormExitCodes = {
        CAPTURE_FUNDS_SUCCESSFUL: 'CAPTURE_FUNDS_SUCCESSFUL',
        CREATE_RECURRING_SUCCESSFUL: 'CREATE_RECURRING_SUCCESSFUL',
        CREATE_TRANSACTION_SUCCESSFUL: 'CREATE_TRANSACTION_SUCCESSFUL',
        CUSTOMER_EMAIL_BLACKLISTED: 'CUSTOMER_EMAIL_BLACKLISTED',
        CUSTOMER_COUNTRY_BLACKLISTED: 'CUSTOMER_COUNTRY_BLACKLISTED',
    };

    /**
     * Displays any page level messages for the user that were included in the response from the server
     *
     * @param {{}} responseStructure as defined withing the _initCheckoutResponseStructure method
     * @return {boolean} True when successful, otherwise false (unexpected error)
     */
    window.JVZoo.Checkout.ProcessResponseDisplayUserMessages = function (responseStructure) {
        if (!responseStructure.data.userMessages) {
            // no user messages to display, so all is well
            return true;
        }
        /*
         * As an 11th hour hack, this code was added to ensure previous validation messages are removed
         */
        var $previousFormAndDisplayMessages = $('.formerror, .alert');
        if ($previousFormAndDisplayMessages.length > 0) {
            $previousFormAndDisplayMessages.each(function(index, element) {
                window.JVZoo.Checkout.Hide(element);
            });
        }

        if (!Array.isArray(responseStructure.data.userMessages)) {
            console.error("Expected responseStructure.data.userMessages to be either null, or an array.");
            return false;
        }

        if (responseStructure.data.fieldMessages.length < 1) {
            // no work to do
            if (window.JVZoo.Debug) {
                console.warn("No form field errors were returned:\n", responseStructure.data.fieldMessages);
            }
            return true;
        }

        if (window.JVZoo.Debug) {
            console.warn(responseStructure.data.userMessages.length + " User Messages Errors:\n", responseStructure.data.userMessages);
        }

        var result = true;
        responseStructure.data.userMessages
            .forEach(function (userMessage) {
                if (!userMessage.level) {
                    console.error("User message did not include a 'level' field.");
                    return result &= false;
                }
                if (!userMessage.message) {
                    console.error("User message did not include a 'level' field.");
                    return result &= false;
                }
                var messageName = userMessage.name || null;
                return result &= _userMessageDisplayDelegate(userMessage.level, userMessage.message, messageName);
            });
        return result === true;
    };

    /**
     * Displays any form field level messages that were included in the response from the server
     *
     * @param {{}} responseStructure as defined withing the _initCheckoutResponseStructure method
     * @return {boolean} True when successful, otherwise false (unexpected error)
     */
    window.JVZoo.Checkout.ProcessResponseDisplayFieldMessages = function (responseStructure) {
        if (!responseStructure.data.fieldMessages) {
            // no work to do
            if (window.JVZoo.Debug) {console.log("Response did not contain field validation errors.");}
            return true;
        }

        if (!Array.isArray(responseStructure.data.fieldMessages)) {
            if (window.JVZoo.Debug) {console.error("Expected responseStructure.data.fieldMessages to be either an array, or null.")}
            return false;
        }

        if (responseStructure.data.fieldMessages.length < 1) {
            // no work to do
            if (window.JVZoo.Debug) {
                console.warn("No form field errors were returned:\n", responseStructure.data.fieldMessages);
            }
            return true;
        }

        if (window.JVZoo.Debug) {console.warn(responseStructure.data.fieldMessages.length+" Validation Errors:\n", responseStructure.data.fieldMessages);}

        var result = true;
        responseStructure.data.fieldMessages.forEach(
            function (fieldMessage) {
                if (!fieldMessage.fieldName || !fieldMessage.errorMessage ) {
                    if (window.JVZoo.Debug) { console.error("Expected field validation message to contain a fieldName and errorMessage property.");}
                    return result &= false;
                }
                var errorDivSelector = '#' + fieldMessage.fieldName + '_error';
                return result &= showErrorField(errorDivSelector, fieldMessage.errorMessage);
            }
        );
        return result === true;
    };

    /**
     * This method is used to process responses that emanate from \Paypal::sendOrderFormJsonResponse. Generally this
     * means a POST was made to \Paypal::orderform. There are also Payment Processors, such as PayPal PCP, which also
     * perform posts to endpoints like \Paypal::\Paypal::PcpOrderApproved and
     * \Paypal::PcpBillingAgreementApproved
     *
     * @param {{}} responseStructure as defined withing the _initCheckoutResponseStructure method
     * @returns {boolean} True when the function was able to handle the response successfully, otherwise false
     * @constructor
     */
    window.JVZoo.Checkout.ProcessJsonOrderFormResponse = function(responseStructure) {
        if (!responseStructure) {
            console.error("Unable to handle an empty response structure.");
            _userMessageDisplayDelegate(
                'error',
                window.JVZoo.Checkout.Messages.NO_RESPONSE_ERROR_MESSAGE,
                window.JVZoo.Checkout.Messages.RESPONSE_PROCESSING_ERROR_MESSAGE_NAME
            );
            return false;
        }
        if (window.JVZoo.Debug) {console.log("window.JVZoo.Checkout.ProcessJsonOrderFormResponse called for: \n", responseStructure);}

        if (!responseStructure.data) {
            return window.JVZoo.Checkout.OrderFormResponseOutcome.INCOMPLETE_RESPONSE_DATA
        }

        if (responseStructure.data.redirectUri) {
            if (window.JVZoo.Debug) {
                console.warn("redirectUri: ", responseStructure.data.redirectUri);
            }
            _userMessageDisplayDelegate(
                'success',
                window.JVZoo.Checkout.Messages.PLEASE_WAIT_FOR_REDIRECT_MESSAGE,
                window.JVZoo.Checkout.Messages.RESPONSE_PROCESSING_OUTCOME_MESSAGE_NAME
            );
            // synchronized with \Paypal::sendOrderFormJsonResponse
            window.location = responseStructure.data.redirectUri;
            return window.JVZoo.Checkout.OrderFormResponseOutcome.REDIRECT;
        }
    };

    var getOrderFormData = function(additionalFields) {
        var myForm = document.getElementById('orderform');
        var formData = new FormData(myForm);
        
        // Update phone number field with international format before form submission
        var visiblePhoneInput = document.getElementById('phone'); // The visible phone field
        if (visiblePhoneInput && visiblePhoneInput.value) {
            var internationalNumber = getInternationalNumber(visiblePhoneInput);
            if (internationalNumber) {
                // Update the FormData with the international format
                formData.set('contact_phone_number', internationalNumber);
            }
        }
        
        if (additionalFields) {
            var keys = Object.entries(additionalFields);
            Object.entries(additionalFields).forEach(
                function (keyValuePair, i) {
                    var key = keyValuePair[0];
                    var value = keyValuePair.length === 2 ? keyValuePair[1] : null;
                    formData.append(key, value);
                }
            );
        }
        return formData;
    };

    window.JVZoo.Checkout.SubmitOrderFormAsPromise = function(
        additionalFormFields,
        defaultResponseHandlerEnabled,
        defaultResponseErrorHandlerEnabled
    ) {
        if (additionalFormFields === undefined) {
            additionalFormFields = new FormData();
            additionalFormFields.formData.append(
                window.JVZoo.Security.GetCsrfFieldName(),
                window.JVZoo.Security.GetCsrfHash()
            );
        }
        if (defaultResponseHandlerEnabled === undefined) {
            defaultResponseHandlerEnabled = true;
        }

        if (defaultResponseErrorHandlerEnabled === undefined) {
            defaultResponseErrorHandlerEnabled = true;
        }

        var requestData = getOrderFormData(additionalFormFields);
        // alert(JSON.stringify(requestData));
        if (window.JVZoo.Debug) {
            console.log("requestData: ", requestData);
        }

        var checkoutResponseStructure = _initCheckoutResponseStructure();
        // alert(JSON.stringify(checkoutResponseStructure));
        // alert(JSON.stringify('requestdata!'));
        // alert(JSON.stringify(requestData));
        return checkoutResponseStructure.request = fetch(
            $('#orderform').attr('action'),
            {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: "same-origin",
                body: requestData,
            }
        )
            .then(_buildDecodeCheckoutResponseHandler(checkoutResponseStructure))
            .then(_buildProcessCheckoutResponseHandler(checkoutResponseStructure, defaultResponseHandlerEnabled))
            .catch(_buildCheckoutResponseErrorHandler(checkoutResponseStructure, defaultResponseErrorHandlerEnabled));
    };

    var _initCheckoutResponseStructure = function() {
      return {
          request: null,
          response: null,
          error: null,
          data: null,
          orderFormExitStatus: null,
          applicationRequestId: '"Checkout Response Failure"'
      }
    };
    window.JVZoo.Checkout.NewCheckoutRepsonseStructure = _initCheckoutResponseStructure;

    var _buildDecodeCheckoutResponseHandler = function(checkoutResponseStructure) {
        return function (response) {
            checkoutResponseStructure.response = response;
//            console.log(JSON.stringify(response));
            if (window.JVZoo.Debug) {
                console.log("response: " + response.statusText + "\n", response);
            }
            if (!response.ok) {
                throw new Error('Network response was not ok: ' + response.statusText);
            }
            return response.json();
        }
    };
    window.JVZoo.Checkout.BuildDecodeCheckoutResponseHandler = _buildDecodeCheckoutResponseHandler;

    var _buildProcessCheckoutResponseHandler = function(checkoutResponseStructure, defaultResponseHandlerEnabled) {
        return function (data) {
            checkoutResponseStructure.data = data;
            if (data.applicationRequestId) {
                checkoutResponseStructure.applicationRequestId = data.applicationRequestId;
            }
            if (data.orderFormExitStatus) {
                checkoutResponseStructure.orderFormExitStatus = data.orderFormExitStatus;

                switch (data.orderFormExitStatus) {
                    case window.JVZoo.Checkout.OrderFormExitCodes.CUSTOMER_EMAIL_BLACKLISTED:
                    case window.JVZoo.Checkout.OrderFormExitCodes.CUSTOMER_COUNTRY_BLACKLISTED:
                        if (data.redirectUri) {
                            window.location.href = data.redirectUri;
                        }
                        break;
                }
            }
            window.JVZoo.Checkout.ProcessResponseDisplayUserMessages(checkoutResponseStructure);
            window.JVZoo.Checkout.ProcessResponseDisplayFieldMessages(checkoutResponseStructure);
            if (!defaultResponseHandlerEnabled) {
                return checkoutResponseStructure;
            }
            return window.JVZoo.Checkout.ProcessJsonOrderFormResponse(checkoutResponseStructure);
        }
    };
    window.JVZoo.Checkout.BuildProcessCheckoutResponseHandler = _buildProcessCheckoutResponseHandler;

    var _buildCheckoutResponseErrorHandler = function(checkoutResponseStructure, defaultResponseErrorHandlerEnabled) {
        return function (error) {
            checkoutResponseStructure.error = error;
            if (window.JVZoo.Debug) {
                console.error("Response Error: ", error);
            }
            if (!defaultResponseErrorHandlerEnabled) {
                throw checkoutResponseStructure;
            }
            _userMessageDisplayDelegate(
                'error',
                window.JVZoo.Checkout.Messages.buildPleaseContactSupport(
                    checkoutResponseStructure.applicationRequestId
                ),
                window.JVZoo.Checkout.Messages.RESPONSE_PROCESSING_OUTCOME_MESSAGE_NAME
            );
            return error;
        }
    };
    window.JVZoo.Checkout.BuildCheckoutResponseErrorHandler = _buildCheckoutResponseErrorHandler;

    var _activityBlocker = function(isEnabled) {
        var selector = window.JVZoo.Checkout.JquerySelectors.jvzOverlay;
        var $overlayElement = $(selector);
        if ($overlayElement.length < 1) {
            console.error("Failed to find the overlay element using the jQuery selector: ", selector);
            return;
        }

        if (isEnabled === true) {
            window.JVZoo.Checkout.Show($overlayElement);
            return;
        }

        window.JVZoo.Checkout.Hide($overlayElement);
    };

    window.JVZoo.Checkout.EnableUserInteraction = function() {
        _activityBlocker(false);
    };

    window.JVZoo.Checkout.DisableUserInteraction = function () {
        _activityBlocker(true);
    };

    window.JVZoo.Checkout.AjaxValidation = function (e) {
        const _validationInProgressMessageName = 'validationInProgress';
        _userMessageDisplayDelegate('info', 'Submitting...', _validationInProgressMessageName);
        window.JVZoo.Checkout.SubmitOrderFormAsPromise({ValidationOnly: 1})
            .then(function (response) {
                console.log("Validation Only Submission Complete:\n", response);
            })
            .catch(function (error) {
                console.error("Validation Only Submission Failed:\n", error);
            })
            .finally(function () {
                window.JVZoo.DisplayMessages.RemoveByName(_validationInProgressMessageName);
            });
    };

    $(document).ready(function () {
        window.JVZoo.Checkout.applyBindings(document);

        // window.JVZoo.RemoteLog.Info("CHECKOUT_JS_LOGGING jvzoo.checkout.js has applied bindings on document ready");
    });
})(window, jQuery);